// extracted by mini-css-extract-plugin
export var category = "_h4-9";
export var categoryHeader = "_h4-e";
export var container = "_h4-0";
export var group = "_h4-a";
export var groupItems = "_h4-f";
export var groupSeparator = "_h4-j";
export var loading = "_h4-1";
export var noResults = "_h4-3";
export var placeholder = "_h4-2";
export var resultContent = "_h4-5";
export var resultIcon = "_h4-c";
export var resultItem = "_h4-g";
export var resultMeta = "_h4-8";
export var resultSubtitle = "_h4-7";
export var resultSuffix = "_h4-i";
export var resultTitle = "_h4-6";
export var resultsList = "_h4-4";
export var searchGroup = "_h4-d";
export var selected = "_h4-h";
export var subgroup = "_h4-b";